import { RoleMatrix } from "../utils/rbacCatalog";

export const initialState = {
  isAuthenticated: false,
  access_token: "",
  entity_identification: "",
  entity_status: "",
  isBasic: false,
  required_password_update: false,
  user_identification: "",
  user_last_connection: "",
  trial_left_days: 0,
  loggedInAt: "",
  customer_plans: [],
  customer_top_plan: "",
  is_new_user: false,
  lastPaymentCheck: 0,
  hasValidSubscription: false,
  exp: "",
  rememberMe: false,
  is_root: false,
  user_role: "DEFAULT",
  user_type: "DEFAULT",
} as IUser;

export interface IUser {
  isAuthenticated: boolean;
  access_token: string;
  entity_identification: string;
  entity_status: string;
  required_password_update: boolean;
  user_identification: string;
  user_last_connection: string;
  customer_top_plan: string;
  trial_left_days: number;
  isBasic: boolean;
  exp: string;
  rememberMe: boolean;
  loggedInAt: string;
  customer_plans: string[];
  is_new_user: boolean;
  lastPaymentCheck: number;
  hasValidSubscription: boolean;
  is_root: boolean;
  user_role?: string;
  userRole?: string;
  is_owner?: boolean;
  user_type?: string;
  role_permissions?: RoleMatrix | null;
  borrows_owner_plan?: boolean;
  owner_plans?: string[];
  owner_top_plan?: string;
  is_promo_trial?: boolean;
  trial_end_date?: string;
  trial_restrictions?: {
    messaging_disabled: boolean;
    sms_disabled: boolean;
    whatsapp_disabled?: boolean;
    api_disabled: boolean;
    ai_disabled?: boolean;
    auto_pilot_disabled?: boolean;
  };
}

export interface AuthContextType {
  isLoading: boolean;
  user: IUser;
  customer_identification: string;
  upgradeNow: boolean;
  userEndedSubscription: boolean;
  permissions: any;
  setUser: (user: IUser) => void;
  login: (credentials: any) => void;
  logout: () => void;
  onOffUpgradeNow: (onOff: boolean) => void;
  onOffUserEndedSubscription: (onOff: boolean) => void;
}

export interface StorageContextType {
  setItem: (item: string, value: string) => void;
  getItem: (key: string) => string | null;
  removeItem: (key: string) => void;
  clear: () => void;
  length: () => number;
}
